import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const DocsIsometricIcon = () => (
  <SvgIcon
    width="54"
    style={{ width: 'auto', height: 'auto', fill: 'none' }}
    height="89"
    viewBox="0 0 54 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.495678 86.6737V86.6762L3.6822 88.516L4.22732 84.0519L29.3715 69.5288C30.2713 69.0093 31.0002 67.7463 31.0002 66.7079L30.9971 11.6709L33.271 1.94961L30.0827 0.108517L30.0808 0.107287L30.0753 0.104232L30.0747 0.104847C29.7805 -0.0611941 29.3764 -0.0355496 28.9302 0.221447L1.62866 15.9843C0.728869 16.5038 0 17.7668 0 18.8052L0.00366065 85.6128C0.00366065 86.1414 0.192898 86.5071 0.495678 86.6737Z"
      fill="#C8E2FF"
    />
    <path
      d="M33.2709 1.94961L30.0826 0.108517L30.0808 0.107287L30.0753 0.104232L30.0747 0.104847C29.7804 -0.0611941 29.3763 -0.0355496 28.9301 0.221447L1.62859 15.9843C1.1787 16.2444 0.771529 16.6894 0.476685 17.2003L15.0437 25.6098L30.9977 16.618L30.997 11.6697L33.2709 1.94961Z"
      fill="#A5CBFA"
    />
    <path
      d="M33.7576 3.01111C33.7576 1.9703 33.0305 1.55031 32.1338 2.07102L4.83167 17.8315C3.92882 18.3522 3.20178 19.6115 3.20178 20.6523L3.2085 87.463C3.2085 88.4971 3.93554 88.9176 4.83228 88.4037L32.135 72.6365C33.0378 72.1158 33.7649 70.8558 33.7649 69.8156L33.7576 3.01111ZM31.3695 70.1294L5.5465 85.0438C4.9446 85.3887 4.46174 85.1127 4.46174 84.4168L4.44282 22.2517C4.44282 21.5619 4.93178 20.7152 5.52758 20.3709L12.1478 16.5404L12.3047 16.4531C12.9066 16.1082 13.3895 16.3902 13.3895 17.08V17.5122C13.3895 17.8198 13.4835 18.0451 13.6465 18.177C13.6654 18.1898 13.6843 18.202 13.7094 18.2142V18.2209C13.9041 18.3338 14.1794 18.3143 14.4803 18.1391L22.4924 13.5126C23.0943 13.1683 23.5772 12.3277 23.5772 11.6318V11.199C23.5772 10.5098 24.0661 9.66922 24.6619 9.31821L31.3573 5.45653C31.9531 5.11163 32.4414 5.38817 32.4414 6.08346L32.4543 68.2425C32.4536 68.9378 31.9708 69.7778 31.3695 70.1294Z"
      fill="#DCEEFF"
    />
    <path
      d="M15.7562 14.4685L19.6435 12.2233C19.9768 12.031 20.2472 12.1183 20.2472 12.4192C20.2472 12.7202 19.9768 13.12 19.6435 13.3129L15.7562 15.5587C15.4229 15.751 15.1525 15.6631 15.1525 15.3622C15.1525 15.0612 15.4229 14.6608 15.7562 14.4685Z"
      fill="#031F60"
    />
    <path
      d="M20.6843 12.1477C20.6843 12.4394 20.8894 12.5573 21.1422 12.412C21.3949 12.2661 21.5994 11.9114 21.5994 11.6196C21.5994 11.3272 21.3943 11.2094 21.1415 11.3553C20.8888 11.5012 20.6843 11.8565 20.6843 12.1477Z"
      fill="#031F60"
    />
    <path
      d="M32.4537 68.2426C32.4537 68.9385 31.9708 69.7784 31.3689 70.1301L5.54594 85.0444C4.94404 85.3893 4.46118 85.1134 4.46118 84.4175V84.1794L4.44226 22.2523C4.44226 21.5625 4.93123 20.7158 5.52702 20.3716L12.1473 16.541L12.3042 16.4537C12.9061 16.1088 13.3889 16.3908 13.3889 17.0806V17.5128C13.3889 18.2094 13.8779 18.4914 14.4798 18.1398L22.4919 13.5132C23.0938 13.1689 23.5766 12.3283 23.5766 11.6324V11.1996C23.5766 10.5104 24.0656 9.66985 24.6614 9.31885L31.1998 5.5451L31.3567 5.45657C31.9525 5.11167 32.4409 5.38821 32.4409 6.0835L32.4537 68.2426Z"
      fill="#031F60"
    />
    <path
      d="M31.3565 5.45604L31.1997 5.54457L29.9067 6.29052L29.9073 67.6133L32.2923 68.9904C32.3931 68.7414 32.4541 68.4838 32.4541 68.2426L32.4413 6.08359C32.4407 5.38768 31.9523 5.11175 31.3565 5.45604Z"
      fill="#1E3779"
    />
    <path
      d="M31.2125 67.4649C31.2125 68.1608 30.7297 69.0008 30.1278 69.3518L4.46167 84.1789L4.44275 22.2518C4.44275 21.562 4.93171 20.7153 5.52751 20.371L12.1478 16.5405V16.7346C12.1478 17.4311 12.6367 17.7131 13.2386 17.3615L13.3888 17.2742V17.5123C13.3888 18.2088 13.8778 18.4908 14.4797 18.1392L22.4917 13.5127C23.0936 13.1684 23.5765 12.3278 23.5765 11.6319V11.1991C23.5765 10.5099 24.0655 9.66933 24.6613 9.31832L31.1997 5.54456L31.2125 67.4649Z"
      fill="#2B3D89"
    />
    <path
      d="M26.445 47.6749C29.4416 36.3646 30.7791 16.3256 31.2009 8.60837L31.2003 5.54395L24.6619 9.31771C24.0661 9.66872 23.5771 10.5093 23.5771 11.1985V11.6313C23.5771 12.3272 23.0942 13.1678 22.4924 13.5121L14.4803 18.1386C13.8784 18.4896 13.3894 18.2076 13.3894 17.5117V17.2736L13.2392 17.3609C12.6373 17.7119 12.1484 17.4299 12.1484 16.734V16.5399L5.52812 20.3704C4.93233 20.7147 4.44336 21.5614 4.44336 22.2512L4.45984 76.842C4.81329 76.6167 21.6383 65.8125 26.445 47.6749Z"
      fill="#344593"
    />
    <path
      d="M13.6459 18.1764L12.4421 17.4238C12.2412 17.2864 12.1472 17.0477 12.1472 16.7339V16.5398L12.3041 16.4525C12.906 16.1076 13.3889 16.3897 13.3889 17.0795V17.5117C13.3889 17.8193 13.4829 18.0446 13.6459 18.1764Z"
      fill="#031F60"
    />
    <path
      opacity="0.2"
      d="M41.2392 65.4272C41.285 65.3143 41.3198 65.2008 41.346 65.086C41.3509 65.0652 41.3564 65.0451 41.3601 65.0237C41.3839 64.9071 41.4004 64.7911 41.4004 64.6794L41.3875 2.52038C41.3875 1.82447 40.8986 1.54855 40.3028 1.89345L40.1459 1.98198L38.853 2.72793V2.72854L33.6074 5.75574C33.0116 6.10675 32.5227 6.94733 32.5227 7.63652V8.06931C32.5227 8.76522 32.0398 9.6058 31.4379 9.95009L23.4258 14.5766C22.8239 14.9277 22.335 14.6456 22.335 13.9497V13.7117V13.5175C22.335 12.8277 21.8521 12.5457 21.2502 12.8906L21.0933 12.9785L14.4731 16.809C13.8773 17.1533 13.3883 18 13.3883 18.6898L13.4072 80.6169V80.855C13.4072 81.5515 13.8901 81.8268 14.492 81.4819L40.315 66.5675C40.7093 66.338 41.0494 65.8985 41.2392 65.4272Z"
      fill="#E9FFFB"
    />
    <path
      d="M41.2392 65.4272C41.285 65.3143 41.3198 65.2008 41.346 65.086C41.3509 65.0652 41.3564 65.0451 41.3601 65.0237C41.3839 64.9071 41.4004 64.7911 41.4004 64.6794L41.3875 2.52038C41.3875 1.82447 40.8986 1.54855 40.3028 1.89345L40.1459 1.98198L38.853 2.72793V2.72854L33.6074 5.75574C33.0116 6.10675 32.5227 6.94733 32.5227 7.63652V8.06931C32.5227 8.76522 32.0398 9.6058 31.4379 9.95009L23.4258 14.5766C22.8239 14.9277 22.335 14.6456 22.335 13.9497V13.7117V13.5175C22.335 12.8277 21.8521 12.5457 21.2502 12.8906L21.0933 12.9785L14.4731 16.809C13.8773 17.1533 13.3883 18 13.3883 18.6898L13.4072 80.6169V80.855C13.4072 81.5515 13.8901 81.8268 14.492 81.4819L40.315 66.5675C40.7093 66.338 41.0493 65.8985 41.2392 65.4272Z"
      stroke="#E9FFFB"
      strokeMiterlimit="10"
    />
    <path
      opacity="0.8"
      d="M27.5341 19.9205V66.1488C27.5341 67.1871 28.2635 67.6083 29.1633 67.0888L51.3713 54.2665C52.2711 53.747 52.9999 52.484 52.9999 51.4456V5.21792C52.9999 4.17955 52.2705 3.75773 51.3713 4.27783L29.1633 17.0996C28.2635 17.6191 27.5341 18.8821 27.5341 19.9205Z"
      fill="#8DA8E7"
    />
    <path
      d="M27.5341 19.9205V66.1488C27.5341 67.1871 28.2635 67.6083 29.1633 67.0888L51.3713 54.2665C52.2711 53.747 52.9999 52.484 52.9999 51.4456V5.21792C52.9999 4.17955 52.2705 3.75773 51.3713 4.27783L29.1633 17.0996C28.2635 17.6191 27.5341 18.8821 27.5341 19.9205Z"
      stroke="#E9FFFB"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.8"
      d="M30.7328 47.8684L39.6159 42.7395C39.9755 42.5319 40.2673 42.6998 40.2673 43.1155V43.1521C40.2673 43.5678 39.9761 44.0733 39.6159 44.2808L30.7328 49.4092C30.3732 49.6167 30.0814 49.4489 30.0814 49.0332V48.9965C30.0808 48.5808 30.3726 48.0754 30.7328 47.8684Z"
      fill="#0B3FA5"
    />
    <path
      opacity="0.8"
      d="M42.1476 41.2786L49.8025 36.859C50.1621 36.6509 50.4539 36.8199 50.4539 37.235V37.2717C50.4539 37.6874 50.1627 38.1922 49.8025 38.3998L42.1482 42.8194C41.7886 43.0275 41.4968 42.8584 41.4968 42.4433V42.4067C41.4956 41.9916 41.788 41.4862 42.1476 41.2786Z"
      fill="#0B3FA5"
    />
    <g opacity="0.8">
      <path
        d="M30.7328 55.1179L39.6159 49.9896C39.9755 49.7821 40.2673 49.9505 40.2673 50.3656V50.4029C40.2673 50.8186 39.9761 51.324 39.6159 51.5316L30.7328 56.6599C30.3732 56.8675 30.0814 56.699 30.0814 56.2839V56.2467C30.0808 55.8309 30.3726 55.3255 30.7328 55.1179Z"
        fill="#0B3FA5"
      />
      <path
        d="M42.1474 48.5289L49.8024 44.1086C50.162 43.9011 50.4538 44.0696 50.4538 44.4847V44.5219C50.4538 44.9376 50.1626 45.4431 49.8024 45.6506L42.1481 50.0702C41.7885 50.2784 41.4967 50.1093 41.4967 49.6942V49.6576C41.4955 49.2419 41.7879 48.7358 42.1474 48.5289Z"
        fill="#0B3FA5"
      />
    </g>
    <g opacity="0.8">
      <path
        d="M30.7328 51.4932L35.5418 48.7163C35.9014 48.5087 36.1932 48.6772 36.1932 49.0923V49.129C36.1932 49.5447 35.9014 50.0501 35.5418 50.2577L30.7328 53.034C30.3732 53.2415 30.0814 53.073 30.0814 52.6579V52.6213C30.0808 52.2062 30.3726 51.7008 30.7328 51.4932Z"
        fill="#0B3FA5"
      />
      <path
        d="M37.7004 47.4691L41.78 45.1006C42.139 44.8924 42.4307 45.0603 42.4307 45.4754V45.512C42.4307 45.9278 42.1396 46.4332 41.78 46.642L37.7004 49.0105C37.3415 49.2193 37.0503 49.0508 37.0503 48.6357V48.5991C37.0503 48.184 37.3415 47.6779 37.7004 47.4691Z"
        fill="#0B3FA5"
      />
      <path
        d="M44.0923 43.7627L49.8017 40.4821C50.1619 40.2752 50.4537 40.4449 50.4537 40.86V40.8972C50.4537 41.3129 50.1613 41.8172 49.8017 42.0241L44.0923 45.304C43.7321 45.511 43.4397 45.3425 43.4397 44.9268V44.8895C43.4397 44.4738 43.7321 43.9696 44.0923 43.7627Z"
        fill="#0B3FA5"
      />
    </g>
    <g opacity="0.8">
      <path
        d="M30.7328 58.7839L38.4805 54.3185C38.8401 54.1109 39.1319 54.2794 39.1319 54.6951V54.7323C39.1319 55.1481 38.8401 55.6529 38.4805 55.8604L30.7328 60.3246C30.3732 60.5322 30.0808 60.3637 30.0808 59.948V59.9113C30.0808 59.4956 30.3732 58.9908 30.7328 58.7839Z"
        fill="#0B3FA5"
      />
      <path
        d="M40.6402 53.0719L44.7192 50.7034C45.0788 50.4946 45.37 50.6631 45.37 51.0782V51.1155C45.37 51.5312 45.0788 52.0366 44.7192 52.2448L40.6402 54.6133C40.2807 54.8221 39.9895 54.6536 39.9895 54.2391V54.2019C39.9895 53.7868 40.2807 53.2807 40.6402 53.0719Z"
        fill="#0B3FA5"
      />
      <path
        d="M47.0317 49.3653L49.8019 47.7726C50.1621 47.5657 50.4539 47.7342 50.4539 48.1499V48.1871C50.4539 48.6028 50.1615 49.1071 49.8019 49.3146L47.0317 50.9067C46.6715 51.1136 46.3798 50.9451 46.3798 50.5294V50.4928C46.3792 50.0771 46.6715 49.5722 47.0317 49.3653Z"
        fill="#0B3FA5"
      />
    </g>
    <path
      opacity="0.8"
      d="M31.3567 42.292L49.1743 32.0042V11.431L31.3256 21.7353L31.3567 42.292Z"
      fill="#0B3FA5"
    />
  </SvgIcon>
);
